import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="text-xl font-bold text-foreground-950">
                {siteConfig.logo}
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {siteConfig.tagline}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">内容分类</h4>
              <div className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">首页</Link>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">关于我们</Link>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">帮助中心</a>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">用户协议</a>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">隐私政策</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
              <div className="flex flex-col gap-2.5">
                <p className="text-sm text-foreground-600">
                  <i className="ri-mail-line mr-2"></i>contact@17yiqicao.com
                </p>
                <p className="text-sm text-foreground-600">
                  <i className="ri-phone-line mr-2"></i>400-888-8888
                </p>
                <div className="flex gap-3 mt-2">
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100/70 transition-colors" aria-label="微信">
                    <i className="ri-wechat-line text-lg"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100/70 transition-colors" aria-label="微博">
                    <i className="ri-weibo-line text-lg"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100/70 transition-colors" aria-label="知乎">
                    <i className="ri-zhihu-line text-lg"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} {siteConfig.name}. 保留所有权利.
            </p>
            <p className="text-xs text-foreground-500">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow" className="hover:text-foreground-700 transition-colors">京ICP备2024000001号</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}